<template>
  <div class="download-body">
    <div class="header">
      <div class="logo">
        <img src="../../assets/icon/logo.png" alt="" />
        <span class="title">榮耀貸</span>
      </div>
      <div class="van-hairline--bottom"></div>
    </div>
    <div class="container">
      <div class="content">
        <div class="left">
          <div>{{ l.download_content_p1 }}</div>
          <div>{{ l.download_content_p2 }}</div>
          <div>{{ l.download_content_p3 }}</div>
        </div>
        <div class="footer">
          <img class="bg" src="../../assets/icon/download.png" alt="" />
          <img class="qr-code" ref="qrCode" />
          <div class="text">{{ l.download_btn_qr_code }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// vayHub
import l from "../../locales";

import QRCode from "qrcode";

export default {
  name: "download",
  data() {
    return {
      l: l.download,
    };
  },
  created() {
    let channel = localStorage.getItem("channel");
    // 生成二维码
    QRCode.toDataURL(
      `${location.protocol}//${location.host}/#/home${
        channel ? "?channel=" + channel : ""
      }`,
      {
        margin: 0, // 留白为空
      }
    )
      .then((url) => {
        this.$refs.qrCode.src = url;
      })
      .catch((err) => {
        console.error("QRCode.toDataURL", err);
      });
  },
};
</script>

<style lang="less" scoped>
html,
body {
  user-select: none;
}
.download-body {
  background: #fff;
  height: 100vh;
  width: 100vw;
  .header {
    padding: 70px 70px 0;
    box-sizing: border-box;
    .logo {
      height: 62px;
      display: flex;
      align-items: center;
      img {
        height: 62px;
        height: 62px;
        border-radius: 10px;
      }
      .title {
        min-width: 220px;
        margin-left: 20px;
        font-size: 30px;
        font-weight: bold;
      }
    }
  }
  .container {
    min-height: 450px;
    position: relative;
  }
  .content {
    position: relative;
    // width: 300px;
    // position: absolute;
    // bottom: 0;
    display: flex;
    justify-content: space-between;
    .left {
        position: absolute;
      width: 550px;
      padding-left: 40px;
      z-index: 100;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
        margin-top: 55px;
      > div:first-child {
        font-family: PingFangSC-Medium;
        font-size: 28px;
        color: #333333;
        letter-spacing: 0.9px;
        margin-top: 55px;
      }
      > div:nth-child(2) {
        font-family: PingFangSC-Medium;
        font-size: 38px;
        color: #00819F;
        letter-spacing: 2.94px;
        margin-top: 45px;
      }
      > div:last-child {
        font-family: PingFangSC-Regular;
        font-size: 22px;
        color: #999999;
        letter-spacing: 0.71px;
        margin-top: 45px;
      }
    }
    .footer {
      position: relative;
      transform: translateX(300px);
      .bg {
        position: absolute;
        top: 0;
        left: 0;
        // 1.9倍
        width: 700px;
      }
      .qr-code {
        position: absolute;
        left: 270px;
        top: 347px;

        width: 180px;
        height: 180px;
      }
      .text {
        width: 277.4px;
        font-family: PingFangSC-Medium;
        font-size: 38px;
        text-align: center;
        color: #00819F;
        letter-spacing: 2px;
        position: absolute;
        left: 225px;
        top: 50px;
      }
    }
  }
}
</style>
